/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable arrow-body-style */
import request from 'services/request';
import * as api from 'services/routes';
import { ResType } from 'types/common.type';
import { calculateWeeks, mapTermData } from 'utils/term.util';
import * as type from './course.constants';

export const getSearchDataAction = () => {
  return async (dispatch): Promise<unknown> => {
    dispatch({ type: type.GET_SEARCH_DATA_REQUEST });

    const response: ResType = await request.get(api.SearchUrl());

    if (response.ok) {
      dispatch({ type: type.GET_SEARCH_DATA_SUCCESS, payload: response.data });
      return response.data;
    }

    dispatch({ type: type.GET_SEARCH_DATA_ERROR });
    return false;
  };
};

export const getChapterAction = (id) => {
  return async (dispatch): Promise<unknown> => {
    dispatch({ type: type.GET_CHAPTER_REQUEST, id });
    const response: ResType = await request.get(api.CourseUrl(id));

    if (response.ok) {
      dispatch({
        type: type.GET_CHAPTER_SUCCESS,
        payload: response.data,
        id,
      });
      return response.data;
    }

    dispatch({ type: type.GET_CHAPTER_ERROR, id });
    return false;
  };
};

export const getSkillsAction = () => {
  return async (dispatch): Promise<unknown> => {
    dispatch({ type: type.GET_SKILLS_REQUEST });
    const response: ResType = await request.get(api.SkillsUrl());

    if (response.ok) {
      dispatch({ type: type.GET_SKILLS_SUCCESS, payload: response.data });
      return response.data;
    }

    dispatch({ type: type.GET_SKILLS_ERROR });
    return false;
  };
};

export const getAdvisorsAction = (value?, id?) => {
  return async (dispatch): Promise<unknown> => {
    dispatch({ type: type.GET_ADVISORS_REQUEST });
    const response: ResType = await request.get(api.ConsultingUrl(value, id));

    if (response.ok) {
      dispatch({ type: type.GET_ADVISORS_SUCCESS, payload: response.data.data });
      return response.data;
    }

    dispatch({ type: type.GET_ADVISORS_ERROR });
    return false;
  };
};

export const getPostsAction = () => {
  return async (dispatch): Promise<unknown> => {
    dispatch({ type: type.GET_POSTS_REQUEST });
    const response: ResType = await request.get(api.PostsUrl());
    if (response.ok) {
      dispatch({ type: type.GET_POSTS_SUCCESS, payload: response.data.data });
      return response.data;
    }

    dispatch({ type: type.GET_POSTS_ERROR });
    return false;
  };
};

export const getTermAction = (id) => {
  return async (dispatch): Promise<unknown> => {
    const response: any = await request.get(api.TermUrl(id)); // eslint-disable-line
    if (response.ok) {
      dispatch({ type: type.SAVE_TERM_WEEKS, payload: response.data.weeks });
      return response.data;
    }

    dispatch({ type: type.SAVE_TERM_WEEKS_ERROR });
    return false;
  };
};

export const saveTermAction = (data, newDays?, newHour?) => {
  return async (dispatch): Promise<void> => {
    const days =
      newDays ||
      (data?.available_days
        ? data?.available_days.filter((k) => k > 0)
        : (
            data.settings?.find((item) => item.term_type === data.term_type) ||
            data.settings[0]
          ).default_days);
    const weekHours =
      newHour ||
      (data?.week_hours
        ? data?.week_hours
        : (
            data.settings?.find((item) => item.term_type === data.term_type) ||
            data.settings[0]
          ).default_hour);
    const list = mapTermData(data);
    const weeks = calculateWeeks(list, days, weekHours);
    const termData = { days, weekHours };
  };
};
